var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 175C58.7776 175 25.2002 141.423 25.2002 100C25.2002 58.5774 58.7776 25 100.2 25C141.623 25 175.2 58.5774 175.2 100C175.2 141.423 141.623 175 100.2 175Z",
    fill: "url(#paint0_linear_26801_1115)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 67C20.2002 63.6863 22.8865 61 26.2002 61H174.2C177.514 61 180.2 63.6863 180.2 67V144C180.2 147.314 177.514 150 174.2 150H26.2002C22.8865 150 20.2002 147.314 20.2002 144V67Z",
    fill: "url(#paint1_linear_26801_1115)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6711 53.9457C36.6711 51.4584 38.7114 49.4421 41.2283 49.4421H86.8C89.3167 49.4421 91.3571 51.4584 91.3571 53.9457V89.9741C91.3571 92.4613 89.3167 94.4776 86.8 94.4776H41.2283C38.7114 94.4776 36.6711 92.4613 36.6711 89.9741V53.9457Z",
    fill: "url(#paint2_linear_26801_1115)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3634 66.891C57.7192 66.891 60.4396 64.1851 60.4396 60.8472C60.4396 57.5094 57.7192 54.8035 54.3634 54.8035C51.0076 54.8035 48.2871 57.5094 48.2871 60.8472C48.2871 64.1851 51.0076 66.891 54.3634 66.891Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5443 88.044H80.4018C81.3913 88.044 82.0162 87.0528 81.5477 86.2309L71.0298 69.2818C70.5352 68.5324 69.3895 68.5082 68.8427 69.2335L60.8743 80.7915L56.6297 76.3168C56.1089 75.8332 55.2496 75.8332 54.7548 76.3409L45.5027 86.1342C44.8777 86.932 45.4767 88.044 46.5443 88.044Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7063 106.273H38.3215C37.4097 106.273 36.6709 105.553 36.6709 104.664C36.6709 103.776 37.4097 103.056 38.3215 103.056H89.7063C90.6181 103.056 91.3569 103.776 91.3569 104.664C91.3569 105.553 90.6181 106.273 89.7063 106.273Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7063 118.068H38.3215C37.4097 118.068 36.6709 117.348 36.6709 116.459C36.6709 115.571 37.4097 114.851 38.3215 114.851H89.7063C90.6181 114.851 91.3569 115.571 91.3569 116.459C91.3569 117.348 90.6181 118.068 89.7063 118.068Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9741 129.863H38.3191C37.4086 129.863 36.6709 129.143 36.6709 128.254C36.6709 127.366 37.4086 126.646 38.3191 126.646H63.9741C64.8846 126.646 65.6223 127.366 65.6223 128.254C65.6223 129.143 64.8844 129.863 63.9741 129.863Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.043 53.9457C109.043 51.4584 111.084 49.4421 113.601 49.4421H159.172C161.689 49.4421 163.729 51.4584 163.729 53.9457V89.9741C163.729 92.4613 161.689 94.4776 159.172 94.4776H113.601C111.084 94.4776 109.043 92.4613 109.043 89.9741V53.9457Z",
    fill: "url(#paint3_linear_26801_1115)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.736 66.891C130.092 66.891 132.812 64.1851 132.812 60.8472C132.812 57.5094 130.092 54.8035 126.736 54.8035C123.38 54.8035 120.66 57.5094 120.66 60.8472C120.66 64.1851 123.38 66.891 126.736 66.891Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.917 88.044H152.775C153.764 88.044 154.389 87.0528 153.921 86.2309L143.403 69.2818C142.908 68.5324 141.762 68.5082 141.215 69.2335L133.247 80.7915L129.002 76.3168C128.482 75.8332 127.622 75.8332 127.128 76.3409L117.876 86.1342C117.251 86.932 117.849 88.044 118.917 88.044Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.079 106.273H110.694C109.782 106.273 109.044 105.553 109.044 104.664C109.044 103.776 109.782 103.056 110.694 103.056H162.079C162.991 103.056 163.73 103.776 163.73 104.664C163.73 105.553 162.991 106.273 162.079 106.273Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.079 118.068H110.694C109.782 118.068 109.044 117.348 109.044 116.459C109.044 115.571 109.782 114.851 110.694 114.851H162.079C162.991 114.851 163.73 115.571 163.73 116.459C163.73 117.348 162.991 118.068 162.079 118.068Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.347 129.863H110.692C109.781 129.863 109.044 129.143 109.044 128.254C109.044 127.366 109.781 126.646 110.692 126.646H136.347C137.257 126.646 137.995 127.366 137.995 128.254C137.995 129.143 137.257 129.863 136.347 129.863Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_1115",
    x: 36.6709,
    y: 102.056,
    width: 54.686,
    height: 27.8069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1115"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1115"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1115",
    result: "effect2_innerShadow_26801_1115"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_1115",
    x: 109.044,
    y: 102.056,
    width: 54.686,
    height: 27.8069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1115"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1115"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1115",
    result: "effect2_innerShadow_26801_1115"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1115",
    x1: 25.2002,
    y1: 36.7188,
    x2: 168.169,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1115",
    x1: 100.2,
    y1: 61,
    x2: 100.2,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1115",
    x1: 42.6524,
    y1: 49.4421,
    x2: 98.4788,
    y2: 91.6991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1115",
    x1: 115.025,
    y1: 49.4421,
    x2: 170.851,
    y2: 91.6991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/Column.3c5230234a6b63e1e5d6b427ac0055e7.svg";
export { ForwardRef as ReactComponent };